<template>
  <el-form :model="form" size="small" :rules="rules" ref="form" class="form-horizontal flex-column prepend-equal dicts-create-form">
    <div class="flex-row flex-wrap justify-content-between form-row">
      <el-form-item prop="provinceCode" v-if="formType === '新增'">
        <div class="select-group required">
          <span class="el-input-group__prepend select-prepend">省份</span>
          <el-select clearable v-model="form.provinceCode" filterable placeholder="——省份——">
            <el-option v-for="item in provinces" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="cityCode" v-show="formType === '新增'">
        <div class="select-group required">
          <span class="el-input-group__prepend select-prepend">城市</span>
          <el-select clearable v-model="form.cityCode" filterable  placeholder="——城市——">
            <el-option v-for="item in cities" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="areaCode" v-show="formType === '新增'">
        <div class="select-group  ">
          <span class="el-input-group__prepend select-prepend">地区</span>
          <el-select clearable v-model="form.areaCode" filterable  placeholder="——地区——">
            <el-option v-for="item in regions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="policeCode" class="required" v-show="formType === '新增'">
        <div class="dis-input-group">
          <el-input placeholder="" v-model="form.preCode" :disabled="true">
            <template slot="prepend">编码</template>
          </el-input>
          <el-input placeholder="不许重复" v-model.trim="form.policeCode" style="width: 90px;">
          </el-input>
        </div>
      </el-form-item>
      <!--<el-form-item prop="policeCode" label="编码" label-width="90px" class="required policeCodeItem" v-show="formType !== '新增'" style="width:100%;color:#333;">
          {{policeStation.policeCode}}
      </el-form-item>-->
      <el-form-item prop="policeCode" v-if="formType !== '新增'"  class="required" style="width: 100%;">
        <el-input placeholder="" v-model="policeStation.policeCode" disabled>
          <template slot="prepend">编码</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="name" class="required">
        <el-input placeholder="" v-model.trim="form.name">
          <template slot="prepend">名称</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="phone" class="required">
        <el-input placeholder="" v-model="form.phone" >
          <template slot="prepend">电话</template>
        </el-input>
      </el-form-item>
    </div>
    <div class="flex-row flex-wrap justify-content-between form-row">
      <el-form-item prop="addr" class="required">
        <el-input placeholder="" v-model="form.addr" >
          <template slot="prepend">地址</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="comment">
        <el-input placeholder="" v-model="form.comment">
          <template slot="prepend">备注</template>
        </el-input>
      </el-form-item>
    </div>
    <div class="flex-row flex-wrap justify-content-between form-row">
      <el-form-item prop="xpoint">
        <el-input placeholder="" v-model="form.xpoint">
          <template slot="prepend">经度</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="ypoint">
        <el-input placeholder="" v-model="form.ypoint">
          <template slot="prepend">纬度</template>
        </el-input>
      </el-form-item>
    </div>

    <div class="text-center p-t-sm">
      <!-- <button class="btn btn-primary btn-save" type="button" @click="submitForm" v-loading="submitLoading">确定</button> -->
      <el-button class="primary-btn-g" icon="CircleCheck" @click="submitForm" v-loading="submitLoading">确定</el-button>
      <!-- <button class="btn btn-white btn-cancle" data-dismiss="modal">取消</button> -->
      <el-button class="warning-btn-g" icon="CircleClose" data-dismiss="modal">取消</el-button>
    </div>
  </el-form>
</template>
<script>
import {
  mapActions
}
from 'vuex'
export default {
  name: 'dictAreaForm',
  props: {
    formType: {
      type: String,
      default: ''
    },
    policeStation: {
      type: Object,
      default: null,
    },
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      provinces: [],
      cities: [],
      regions: [],
      submitLoading: false,
      form: {
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        policeCode: '',
        name: '',
        addr: '',
        phone: '',
        xpoint: '',
        ypoint: '',
        comment: '',
        preCode:''
      },
      rules: {
        provinceCode: [{
          required: true,
          message: '请选择省份',
          trigger: 'blur, change'
        }],
        cityCode: [{
          required: true,
          message: '请选择城市',
          trigger: 'blur, change'
        }],
       /* areaCode: [{
          required: true,
          message: '请选择地区',
          trigger: 'blur, change'
        }],*/
        policeCode: [{
          required: true,
          message: '请输入派出所编码',
          trigger: 'blur'
        },],
        name: [{
          required: true,
          message: '请输入派出所名称',
          trigger: 'blur'
        }],
        addr: [{
          required: true,
          message: '请输入派出所地址',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入派出所电话',
          trigger: 'blur'
        }]
      }
    }
  },
  created() {
    let params = {
      areaCode: 0
    }
    let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
    this._fetchBasicalData(url, params, 'provinces')
  },
  watch: {
    modalShow(to) {
      this.$refs.form.resetFields()
      if (this.policeStation !== null) {
        this.form = {
          ...this.form,
          ...this.policeStation,
          policeCode: this.policeStation.policeCode.slice(6)
        }
        setTimeout(() => {
          this.form.cityCode = this.policeStation.cityCode
        }, 10)
        setTimeout(() => {
          this.form.areaCode = this.policeStation.areaCode.substring(4)=='00'?'':this.policeStation.areaCode
        }, 15)
      }
    },
    'form.provinceCode': function(to) {
      this.form.cityCode = ''
      let params = {
        areaCode: to
      }
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
      this._fetchBasicalData(url, params, 'cities')
    },
    'form.cityCode': function(to) {
      this.form.areaCode = ''
      let params = {
        areaCode: to
      }
      this.form.preCode = to
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
      this._fetchBasicalData(url, params, 'regions')
    },
    'form.areaCode': function(to) {
      if(to){
        this.form.preCode = to
      }else{
        this.form.preCode = this.form.cityCode
      }

    },
  },
  mounted() {
    if (this.policeStation !== null) {
      this.form = {
        ...this.form,
        ...this.policeStation,
        policeCode: this.policeStation.policeCode.slice(6)
      }
      setTimeout(() => {
        this.form.cityCode = this.policeStation.cityCode
      }, 10)

      setTimeout(() => {
        this.form.areaCode = this.policeStation.areaCode.substring(4)=='00'?'':this.policeStation.areaCode
      }, 15)
    }
  },
  methods: {
    ...mapActions([
      'alertToggle',
      'fetchData'
    ]),
    _fetchBasicalData(url, params, type) {
      const _this = this
      this.fetchData({url, method: 'get', params}).then(res => {
        this[type] = res.data
      }).catch(err => {
        this.error = err
      })
    },
    submitForm() {
      const _this = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = this.formType === '新增' ?
            'DICT.POLICE_STATION_ADD' :
            'DICT.POLICE_STATION_UPDATE';
          let policeStation = {
            ...this.form,
            policeCode: this.form.preCode + this.form.policeCode
          }
          policeStation.areaCode = this.form.areaCode?this.form.areaCode:this.form.cityCode
          let params = {
            policeStation: JSON.stringify(policeStation)
          }
          this.submitLoading = true
          this.fetchData({
            url,
            method: 'post',
            params,
            timeout:0,
            isLoading:false,
            flag:true
          }).then(res => {
            if(res && res.status==1){
              _this.alertToggle({
                alertType: 'success',
                alertContent: res.msg||'操作成功'
              })
              _this._finishOperate()
            }else{
              let tipMsg = (res && res.msg) ? res.msg:'操作失败'
              _this.alertToggle({
                alertType: 'danger',
                alertContent: tipMsg
              })
              this.submitLoading = false
            }

          }).catch(err => {
            _this.submitLoading = false
            if(err.indexOf('编码') > -1){
              let field = _this.$refs.form.fields.filter(field => field.prop === 'policeCode')[0];
              field.validateMessage = err
              field.validateState = 'error'
            }
            return false
          })
        }else{
          return false;
        }
      });
    },
    _finishOperate() {
      this.submitLoading = false
      this.$emit('success', { province: this.form.provinceCode, city: this.form.cityCode, region: this.form.areaCode })
    }
  }

}
</script>
